"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/arrayToObject.js
// module id = 2106
// module chunks = 0